import { styled } from '@linaria/react';

import { CATEGORIES } from '@/helpers/category.helpers';

import FooterLink from './FooterLink';

function CategoryList() {
  return (
    <TwoColumnList>
      {CATEGORIES.map((category) => {
        return (
          <li key={category.slug}>
            <FooterLink
              href={`/${category.slug}`}
              translate={category.translate}
            >
              {category.name}
            </FooterLink>
          </li>
        );
      })}
    </TwoColumnList>
  );
}

const TwoColumnList = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding: 0;
  list-style-type: none;

  li {
    text-align: left;
  }
`;

export default CategoryList;
